import React, { useState,useRef,useEffect  } from 'react';
import axios from 'axios';
import '../App.css';
import RichTextEditor from "../shared/RichTextEditor"; // adjust path as needed
import {subscribe,unsubscribe} from '../../utils/pubsubWrapper';

function VideoCreateForm() {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    duration: '',
    topic: '',
    skillLevel: '',
    tags: '',
    thumbnailUrl:'https://yourcdn.com/thumbnails/intro-thumb.jpg',
    createdBy: '64e77b2c74e913f546785f00',
    updatedBy: '64e77b2c74e913f546785f00'
  });
  const [videoFile, setVideoFile] = useState(null);
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState('');
  const [richTextDescription,setRichTextDescription] = useState({});
  const editorRef = useRef();


  useEffect(() => {
  const pubsubToken = subscribe('Rich_Text_Set', (data) => {
         console.log('Rich text contents are edited:', data);
         setRichTextDescription(data);
        });

      return () => unsubscribe(pubsubToken); // clean up
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setVideoFile(e.target.files[0]);
  };

  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    setThumbnailFile(file);
    // if (file) {
    //   setPreviewUrl(URL.createObjectURL(file));
    // }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!videoFile) {
      setMessage('Please select a video file.');
      return;
    };

    const data = new FormData();
    formData["description"] = JSON.stringify(richTextDescription);
    Object.keys(formData).forEach(key => data.append(key, formData[key]));
    data.append('video', videoFile);
    if (thumbnailFile) data.append('thumbnail', thumbnailFile);
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/videos/upload`, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setProgress(percent);
        }
      });

      if (response.status === 201) {
        setMessage('✅ Video uploaded successfully!');
      } else {
        setMessage('❌ Upload failed.');
      }
    } catch (error) {
      console.error('Upload error:', error);
      setMessage('❌ Upload failed.');
    }
  };
  
  return (
    <div className="video-upload-container">
      <h2 className="text-xl font-bold mb-4">Upload Video</h2>
      <form onSubmit={handleSubmit} className="video-upload-form">
        <input name="title" placeholder="Title" value={formData.title} onChange={handleInputChange} required className="w-full p-2 border" />
        <textarea name="description" placeholder="Description" value={formData.description} onChange={handleInputChange} required className="w-full p-2 border" />
         <RichTextEditor ref={editorRef} />
        <input type="number" name="duration" placeholder="Duration (seconds)" value={formData.duration} onChange={handleInputChange} required className="w-full p-2 border" />
        <input name="topic" placeholder="Topic" value={formData.topic} onChange={handleInputChange} className="w-full p-2 border" />
        <input name="skillLevel" placeholder="Skill Level" value={formData.skillLevel} onChange={handleInputChange} className="w-full p-2 border" />
        <input name="tags" placeholder="Keywords (comma separated)" value={formData.tags} onChange={handleInputChange} className="w-full p-2 border" />

        <input type="file" accept="video/*" name="Upload Video" onChange={handleFileChange} required className="w-full" />
        <input type="file" accept="image/*" name="Upload thumbnail image" onChange={handleThumbnailChange} className="w-full" />
        <button type="submit" className="btn">Upload</button>
      </form>

      {progress > 0 && <p className="upload-progress">Upload Progress: {progress}%</p>}
      {message && <p className="upload-message">{message}</p>}
    </div>
  );
}

export default VideoCreateForm;
